import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-leandroalvinia',
  templateUrl: './leandroalvinia.component.html',
  styleUrls: ['./leandroalvinia.component.css']
})
export class LeandroalviniaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
